// extracted by mini-css-extract-plugin
module.exports = {"root":"Subtitle_root__1cVwG","container":"Subtitle_container__1O3QL","text":"Subtitle_text__2IsYN","scrollImg":"Subtitle_scrollImg___NRyN"};